import http from "@/utils/request"

export default {
	captcha: async function (data = {}) {
		return await http.get("captcha", data);
	},
	login: async function (data = {}) {
		return await http.post("login", data);
	},
	info: async function () {
		return await http.get("info");
	},
	menu: async function (data = {}) {
		return await http.get("menu", data)
	},
	logout: async function () {
		return await http.get("logout");
	},
	saveTag: async function (data = {}) {
		return await http.post("save/tag", data);
	},
	saveInfo: async function (data = {}) {
		return await http.post("save/info", data);
	},
	loginLog: async function (data) {
		return await http.get("log/login", data);
	},
	changePwd: async function (data = {}) {
		return await http.post("change/pwd", data);
	},
	saveDashboard: async function (data = {}) {
		return await http.post("save/dashboard", data);
	},
	saveReserved: async function (data = {}) {
		return await http.post("save/reserved", data);
	},
	chat: {
		list: async function (data = {}) {
			return await http.get("chat/list", data);
		},
		add: async function (data = {}) {
			return await http.post("chat/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("chat/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("chat/del", data);
		},
		history: async function (data = {}) {
			return await http.get("chat/history", data);
		},
	},
}
